import { create } from 'zustand';

export interface ToastItem {
  id: number;
  message: string;
  tone: 'ok' | 'danger';
}

interface ToastState {
  items: ToastItem[];
  push: (message: string, tone?: 'ok' | 'danger') => void;
  dismiss: (id: number) => void;
}

let nextId = 1;

export const useToastStore = create<ToastState>((set) => ({
  items: [],
  push: (message, tone = 'ok') => {
    const id = nextId;
    nextId += 1;
    set((state) => ({ items: [...state.items, { id, message, tone }] }));
    window.setTimeout(() => {
      set((state) => ({ items: state.items.filter((item) => item.id !== id) }));
    }, 4000);
  },
  dismiss: (id) => set((state) => ({ items: state.items.filter((item) => item.id !== id) })),
}));
